import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Symptoms', href: '/symptoms' },
    { name: 'Research', href: '/research' },
    { name: 'Resources', href: '/resources' },
    { name: 'Get Involved', href: '/get-involved' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage
          ? 'bg-white/95 backdrop-blur-md border-b border-blue-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            {/* On homepage at top: dark-bg logo. Once scrolled or on other pages: text fallback until light logo is provided */}
            {isHomePage && !isScrolled ? (
              <a href="/">
                <img
                  src="https://storage.readdy-site.link/project_files/c4084cf6-f9fc-491d-816c-98ce35896c67/6f9e6aa7-09db-4a9b-9ba0-39ddfb321c10_CSCF_Logo_ON_DARK_HORIZONTAL.png?v=acda9b505a48b061efb7c407bb65535c"
                  alt="CSCF Support"
                  className="h-16 w-auto object-contain"
                />
              </a>
            ) : (
              <a href="/">
                <img
                  src="https://storage.readdy-site.link/project_files/c4084cf6-f9fc-491d-816c-98ce35896c67/e0d5735a-cec2-44c8-b463-2700f303076d_CSCF_Logo_ON_WHITE_HORIZONTAL.png?v=b87494f1f6ee281b4517518ad8127ac2"
                  alt="CSCF Support"
                  className="h-16 w-auto object-contain"
                />
              </a>
            )}
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-7">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`text-sm font-medium transition-colors hover:text-brand-500 whitespace-nowrap font-body ${
                  isScrolled || !isHomePage ? 'text-gray-600' : 'text-white'
                }`}
              >
                {link.name}
              </a>
            ))}
            <a
              href="https://www.facebook.com/share/g/1BT8NGBZVX/?mibextid=K35XfP"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-brand-500 text-white text-sm font-semibold rounded-full hover:bg-brand-600 transition-colors whitespace-nowrap cursor-pointer font-body shadow-sm"
            >
              Join Community
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i
              className={`text-2xl ${isScrolled || !isHomePage ? 'text-gray-800' : 'text-white'} ${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-6 py-5 space-y-3">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="block text-gray-700 text-sm font-medium hover:text-brand-500 transition-colors whitespace-nowrap font-body py-1"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a
              href="https://www.facebook.com/share/g/1BT8NGBZVX/?mibextid=K35XfP"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full px-5 py-2.5 bg-brand-500 text-white text-sm font-semibold rounded-full hover:bg-brand-600 transition-colors text-center whitespace-nowrap cursor-pointer font-body mt-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Join Community
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
